var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"color":_vm.props.color,"timeout":_vm.props.timeout,"top":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v(" "+_vm._s(_vm.props.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }